import { useEffect, useState } from "react";
import { toast, ToastContainer } from "react-toastify";
import { ManufacturingCostService } from "../../../services/manufacturingCost";
import { useAsync } from "../../../utils/hooks/useAsync";
import useModal from "../../../utils/hooks/useModal";
import { Icon } from "../../Icon";
import Modal from "../../common/Modal/Modal";
import AddManufacturingCost from "../AddManufacturingCost";
import { AdminService } from "../utils";
import "./AddManufacturingCostContainer.scss";
import Label from "../../Label";
import { useNavigate } from "react-router-dom";
import CurrencyInput from "react-currency-input-field";
import Loading from "../../common/Loading";

const AddManufacturingCostContainer = () => {
  const { isSuccess, isLoading, run } = useAsync();

  const navigate = useNavigate();
  const { isOpen, toggle } = useModal();
  const [deleteModal, setDeleteModal] = useState(false);
  const [editManufacturingCost, setEditManufacturingCost] = useState<ManufacturingCost>({
    title: "",
    value: 0,
    description: "",
    material: "",
  });
  const [manufacturingCost, setManufacturingCost] = useState<ManufacturingCost[]>([]);
  const [newManufacturingCost, setNewManufacturingCost] = useState(false);

  useEffect(() => {
    ManufacturingCostService.getManufacturingCost().then((data) => {
      setManufacturingCost(
        data.data.sort(function (a: ManufacturingCost, b: ManufacturingCost) {
          if (a.material < b.material) {
            return -1;
          }
          if (a.material > b.material) {
            return 1;
          }
          return 0;
        })
      );
      setNewManufacturingCost(false);
    });
  }, []);
  useEffect(() => {
    run(ManufacturingCostService.getManufacturingCost()).then((data: any) => {
      setManufacturingCost(
        data.data.sort(function (a: ManufacturingCost, b: ManufacturingCost) {
          if (a.material < b.material) {
            return -1;
          }
          if (a.material > b.material) {
            return 1;
          }
          return 0;
        })
      );
      setNewManufacturingCost(false);
    });
  }, [newManufacturingCost]);
  const updateManufacturingCost = (mc: ManufacturingCost) => {
    AdminService.updateMannufacturingCost(mc).then((r) => {
      setNewManufacturingCost(true);
      toast.success("Hechura modificada correctamente");
      toggle();
    });
  };

  const handleCloseDelete = () => {
    setDeleteModal(false);
    toggle();
  };

  const handleEdit = (mc: ManufacturingCost) => {
    setEditManufacturingCost(mc);
    toggle();
  };

  const handleDelete = (mc: string) => {
    AdminService.deleteMannufacturingCost(mc).then((r) => {
      if (r.exist.deletedCount < 0) {
        setDeleteModal(true);
        toggle();
      } else {
        toast.success("Hechura eliminada correctamente");
        setManufacturingCost(manufacturingCost.filter((el) => el._id != mc));
      }
    });
  };

  const handleChange = (e: any) => {
    e.preventDefault();
    setEditManufacturingCost({
      ...editManufacturingCost,
      [e.currentTarget.name]: e.currentTarget.value,
    });
  };
  const handleChangeValue = (name: string, value: string) => {
    setEditManufacturingCost({
      ...editManufacturingCost,
      [name]: value.replace(",", "."),
    });
  };

  const childrenDelete = () => (
    <div className="childrenDelete">
      <div className="childrenDelete_Header">
        <div className="childrenDelete_Header_Left">
          <Icon iconName="alert_icon" className="childrenDelete_Header_Left_Icon" />
          <h4>Atención</h4>
        </div>
        <p onClick={handleCloseDelete}>X</p>
      </div>
      <div className="childrenDelete_Body">
        <h3>No se puede eliminar la hechura.</h3>
        <p>Existen variaciones vinculadas a la hechura. Para eliminarla, primero borre las relaciones con la hechura desde el producto.</p>
      </div>
      <div className="childrenDelete_Buttons">
        <button type="button" className="childrenDelete_Buttons_Cancel" onClick={handleCloseDelete}>
          Cancelar
        </button>
        <button className="childrenDelete_Buttons_Navigate" onClick={() => navigate("/admin/see")}>
          Productos
        </button>
      </div>
    </div>
  );

  const childrenEdit = (manufacturingCost: ManufacturingCost) => (
    <div className="childrenEdit">
      <div className="childrenEdit_Header">
        <h2 className="childrenEdit_Header__title">Editar Hechura</h2>
        <div onClick={toggle}>
          <Icon iconName="close_icon" className="childrenEdit_Header__close" />
        </div>
      </div>
      <label>
        Título:
        <input type="text" name="title" id="title" onChange={handleChange} value={manufacturingCost.title} />
      </label>
      <label>
        Descripción:
        <input type="text" name="description" id="description" onChange={handleChange} value={manufacturingCost.description}></input>
      </label>
      <label>
        Valor:
        <CurrencyInput
          id="input-example"
          name="value"
          placeholder="$"
          defaultValue={manufacturingCost.value}
          decimalsLimit={2}
          disableGroupSeparators={false}
          allowNegativeValue={false}
          prefix="$ "
          groupSeparator="."
          decimalSeparator=","
          onValueChange={(name, value) => handleChangeValue(value ? value : "0", name ? name : "")}
        />
      </label>
      <div className="childrenDelete_Buttons">
        <button type="button" className="childrenDelete_Buttons_Cancel" onClick={toggle}>
          Cancelar
        </button>
        <button type="button" className="childrenDelete_Buttons_Navigate" onClick={() => updateManufacturingCost(manufacturingCost)}>
          Guardar
        </button>
      </div>
    </div>
  );

  return (
    <>
      <ToastContainer autoClose={1500} position={"bottom-left"} />
      <AddManufacturingCost setState={setNewManufacturingCost} />
      {manufacturingCost && (
        <Label
          tag="h3"
          className="manufacturingCostTitle"
          style={{
            textAlign: "left",
            fontFamily: "Mont-Semibold",
            marginBottom: "1.5rem",
          }}
        >
          Hechuras
        </Label>
      )}
      {manufacturingCost &&
        isSuccess &&
        manufacturingCost.map((mc) => {
          return (
            <div className="listManufacturingCost" key={mc._id}>
              {mc.material == "gold" ? (
                <h5
                  className="listManufacturingCost_short_button"
                  style={{
                    backgroundColor: "#DCBB33",
                    color: "white",
                    fontSize: "11px",
                    fontFamily: "Mont-Semibold",
                  }}
                >
                  ORO
                </h5>
              ) : (
                <h5
                  className="listManufacturingCost_short_button"
                  style={{
                    backgroundColor: "#EBEBEC",
                    color: "#3E3B4C",
                    fontSize: "11px",
                    fontFamily: "Mont-Semibold",
                  }}
                >
                  PLATA
                </h5>
              )}
              <h5 className="listManufacturingCost_mid">{mc.title.substring(0, 20)}</h5>
              <h5 className="listManufacturingCost_long">{mc.description.substring(0, 50)}</h5>
              <h5 className="listManufacturingCost_short">
                Hechura:{" "}
                {Intl.NumberFormat("es-AR", {
                  style: "currency",
                  currency: "ARS",
                }).format(mc.value)}
              </h5>
              <button className="listManufacturingCost_button_edit" type="button" onClick={() => handleEdit(mc)} key={mc._id + "edit"}>
                <Icon iconName="edit_icon_admin" />
              </button>

              <button className="listManufacturingCost_button_edit" type="button" onClick={() => handleDelete(mc._id || "")} key={mc._id + "delete"}>
                <Icon iconName="trash_cart" />
              </button>
            </div>
          );
        })}
      {isOpen && <Modal isOpen={true} style={{ backgroundColor: "white" }} toggle={toggle} children={deleteModal ? childrenDelete() : childrenEdit(editManufacturingCost)} />}
      {isLoading && <Loading />}
    </>
  );
};

export default AddManufacturingCostContainer;
